import { getFullName } from "utils/getFullName";
import { toInitials } from "utils/toInitials";

const FULL_NAME_PARAMS = {
  fallback: "actorUserName",
  firstNameKey: "userFirstName",
  lastNameKey: "userLastName",
};

const mapActivityLogEntry = (entry) => {
  const displayName = getFullName(entry, FULL_NAME_PARAMS);
  return {
    id: entry.id,
    userName: displayName,
    userInitials: toInitials(displayName, entry.actorUserName),
    area: entry.area,
    areaLabel: entry.areaLabel,
    location: entry.subArea,
    locationLabel: entry.subAreaLabel,
    item: entry.name,
    type: entry.action,
    typeLabel: entry.actionLabel,
    description: entry.description,
    metadata: entry.metadata ?? null,
    timestamp: entry.eventTimestamp,
    targetRef: entry.targetRef ?? null,
    targetMissing: Boolean(entry.targetMissing),
    targetArchived: Boolean(entry.targetArchived),
  };
};

export default mapActivityLogEntry;
